/** Action names */

export const FETCH_CGM_LIST = 'GET_CGM_LIST';
export const FETCH_CGM_TME_LIST = 'GET_CGM_TME_LIST';
export const DELETE_CGM = 'DELETE_CGM';
export const LINK_CGM_TO_PARTICIPANT = 'LINK_CGM_TO_PARTICIPANT';
export const UNLINK_CGM_TO_PARTICIPANT = 'UNLINK_CGM_TO_PARTICIPANT';
